import { render, staticRenderFns } from "./StatusGateway.vue?vue&type=template&id=ebc064ba&scoped=true&"
import script from "./StatusGateway.vue?vue&type=script&lang=js&"
export * from "./StatusGateway.vue?vue&type=script&lang=js&"
import style0 from "./StatusGateway.vue?vue&type=style&index=0&id=ebc064ba&prod&lang=scss&scoped=true&"
import style1 from "./StatusGateway.vue?vue&type=style&index=1&id=ebc064ba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc064ba",
  null
  
)

export default component.exports